export const getShipmentVerificationType = (selectedOption: string, verificationType: any) => {
    if (selectedOption === 'OTP') {
        return verificationType.OTP;
    }
    if (selectedOption === 'Identity') {
        return verificationType.Identity;
    }
    return null;
};

export const validateShipmentStatusSave = (options: {
    selectedState: string;
    selectedShipment: any;
    isVerified: boolean;
    textBoxDesi: string;
    textBoxPackageCount: string;
    selectedCancelState: string;
    textBoxValue: string;
    showCrmCaseIdField: boolean;
    crmCaseId: string;
    showNonTrCodInfo: boolean;
    t: (key: string) => string;
}): string | null => {
    const {
        selectedState,
        selectedShipment,
        isVerified,
        textBoxDesi,
        textBoxPackageCount,
        selectedCancelState,
        textBoxValue,
        showCrmCaseIdField,
        crmCaseId,
        showNonTrCodInfo,
        t,
    } = options;

    if (selectedState == '6' && selectedShipment.statusId == 29 && !isVerified) {
        return t('orderDetail.verificationRequired');
    }
    if (selectedState == '19' && selectedShipment.statusId == 5 && selectedShipment.isSellerStore) {
        if (!textBoxDesi || !textBoxPackageCount) {
            return t('orderDetail.enterDesiAndPackageCount');
        }
    }
    if (selectedState == '2') {
        if (selectedCancelState == '') {
            return t('orderDetail.selectCancelReason');
        }
        if (
            (selectedCancelState == 'CancelReason_Backend_Other' || selectedCancelState == 'Diğer') &&
            textBoxValue == ''
        ) {
            return t('orderDetail.enterCancelReason');
        }
    }
    if (showCrmCaseIdField && !crmCaseId?.trim() && showNonTrCodInfo) {
        return t('orderDetail.pleaseFillAllFields');
    }

    return null;
};
